import { useEffect, useState } from "react";
import { getPropertiesByIdService } from "../../../../Services/CRMAdminServices/CRMPropertyService";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";

export const PropertyFlyer = (selectedFlyer: any) => {
  if (!selectedFlyer) return "";

  return `
    <div style=" padding: 15px;">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div style="flex: 1;">
          <img src="fintracklogo.png" style="height: 50px;" />
        </div>
        <div style="flex: 1; text-align: right;">
          <h2 style="color: blue; font-size: 30px; font-weight: bold; margin: 0;">${selectedFlyer.propertyType}</h2>
        </div>
      </div> 
      <img src="/flyer-banner.png" style="width: 100%; height: 350px; margin-top: 10px;" />
  
      <div style="text-align: left; display: flex; justify-content: space-between; margin-top: 5px;">
  <div>
    <p style="color: blue; font-size: 20px; margin: 1px 0;"><strong>$${selectedFlyer.price1Bedroom}</strong></p>
    <p style="color: blue; font-size: 18px; margin: 1px 0;"><strong>${selectedFlyer.lotNumber} ${selectedFlyer.propertyAddress}</strong></p>
    <p style="color: blue; font-size: 18px; margin: 2px 0;"><strong>${selectedFlyer.estate}</strong></p>
    <p style="color: blue; font-size: 18px; margin: 2px 0;"><strong>${selectedFlyer.areaName}</strong></p>
    <p style="color: blue; font-size: 18px; margin: 2px 0;"><strong>${selectedFlyer.suburb} - ${selectedFlyer.stateName} ${selectedFlyer.postcode}</strong></p>
  </div>

  <div>
    <h2 style="color: blue; font-size: 18px; text-align: right; margin: 2px 0;"><strong>ID - ${selectedFlyer.propertyId}</strong></h2>
    <h3 style="color: blue; font-size: 18px; margin: 40px 0 2px 0; text-align: right;"><strong>Bed / Bath / Car: ${selectedFlyer.bedrooms} - ${selectedFlyer.bath} - ${selectedFlyer.carspots}</strong></h3>
  </div>
</div>

      <div style="width: 100%; height: 1px; background-color: blue; margin: 10px 0;"></div>

      <div style="display: flex; text-align: left; padding: 10px 0; justify-content: space-between;">
        <div>
          <p style="color: black; font-size: 18px; font-weight: bold;"> House </p>
          <p style="color: black; font-size: 18px;"> House Price: ${"$" + selectedFlyer.housePrice} </p>
          <p style="color: black; font-size: 18px;">  House Size:${selectedFlyer.houseSize + "m2"} </p>
          <p style="color: black; font-size: 18px;"> Storey: ${selectedFlyer.storey} </p>
        </div>
        <div>
          <p style="color: black; font-size: 18px; font-weight: bold;">Land Details</p>
          <p style="color: black; font-size: 18px;">Land Price: ${"$" + selectedFlyer.landPrice}</p>
          <p style="color: black; font-size: 18px;">Land Size: ${selectedFlyer.landSize + "m2"}</p>
          <p style="color: black; font-size: 18px;">Title:${selectedFlyer.titled}</p>
        </div>
         <div display: flex; flex-direction: column; justify-content:space-between;">
        <p style="color: black; font-size: 18px; font-weight: bold;">Rental</p>
        <p style="color: black; font-size: 18px;">Rent Yield %: ${selectedFlyer.rentYield}</p>
        <p style="color: black; font-size: 18px;">Rent Weekly: ${"$" + selectedFlyer.rentDollar}</p>
      </div>
      </div>

     
      <div style="width: 100%; height: 1px; background-color: blue; margin: 10px 0;"></div>


      <div style="display: flex; gap:10px; padding: 10px 0;">
       <img src="/richard.jpg" style="width:140px; height:120px; margin-top: 10px;" />
       <div display: flex; flex-direction: column; style="margin-top: 45px;">

       <h3 style="color: blue; font-weight: bold; ">Richard Houston</h3>
          <h3 style="color: blue; font-weight: bold;">0402 838 688</h3>
             <h3 style="color: blue; font-weight: bold; ">help@fintrack.com.au</h3>
       </div>
      </div>


 <div style="width: 100%; height: 1px; background-color: blue; margin: 10px 0;"></div>
      <div style=" font-size: 12px; text-align: left;">
        <p style="margin: 0; padding: 0;">DISCLAIMER:</p>
        <p style="margin: 0; padding: 0;">Please refer to the Consultant for floor plans and other information. Package prices is All buildings are subject to developer’s final approval. Package price does not include government charges such as stamp duty or legal costs. Plans are owned by the builder and may not be copied or reproduced without written permission. Images are for illustrative purposes only and may not represent actual inclusions, facades or floor plans. Please refer to the final contract documents and final working drawings for exact details Fintrack Pty Ltd ACN 006 164 709.  </p>
       
      </div>
    </div>
  `;
};

export const PackageDownload = async (selectedPackage: any) => {
  return `
    <div style="border: 1px solid #bbb; font-family: Arial, sans-serif; background: #fff; max-width: 700px; margin: auto; min-height: 100vh; display: flex; flex-direction: column;">
      <!-- Logo and Property Type Centered -->
      <div style="text-align: center; padding: 30px 0; background: #fff;">
        <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 15px;">
          <img src="fintracklogo.png" alt="Fintrack Logo" style="height: 60px;"  />
        </div>
        <p style="color: #1919FF; font-size: 24px; font-weight: bold;">${selectedPackage.propertyType || 'Property Type'}</p>
      </div>

      <!-- Facade Image -->
      <div style="margin: 0 24px;  width: height: 220px; height: 220px; display: flex; align-items: center; justify-content: center; overflow: hidden;">
        ${selectedPackage?.builderFaçadePageimage ?
      `<img src="${selectedPackage.builderFaçadePageimage}" alt="Facade Image" style="width: 100%; height: auto; max-height: 400px; object-fit: cover;" />` :
      `<span style="font-size: 32px; color: #222;">Facade Image</span>`
    }
      </div>

      <!-- Green Price and Address Section -->
      <div style="padding: 24px;">
        <div style="color: #1919FF; font-size: 26px; font-weight: bold;">ID - ${selectedPackage.propertyId} - $${selectedPackage.price1Bedroom}</div>
        <div style="color: #1919FF; font-size: 18px; font-weight: 500;">${selectedPackage.lotNumber}  ${selectedPackage.propertyAddress} </div>
        <div style="color: #1919FF; font-size: 18px;">${selectedPackage.estate}</div>
         <div style="color: #1919FF; font-size: 18px;"> ${selectedPackage.suburb} - ${selectedPackage.stateName}  ${selectedPackage.postcode}</div>
      </div>

      <!-- First Row: Building and Income -->
      <div style="display: flex; justify-content: space-between; padding: 0 24px; font-size: 16px; margin-bottom: 24px;">
        <div style="flex: 1; min-width: 120px;">
          <div style="font-weight: bold;">BUILDING</div>
          <div>House Price: <span style="font-weight: 500;">${selectedPackage.housePrice ? "$" + selectedPackage.housePrice : "-"}</span></div>
          <div>House Size SQM: <span style="font-weight: 500;">${selectedPackage.houseSize || "-"}</span></div>
          <div>Storey: <span style="font-weight: 500;">${selectedPackage.storey || "-"}</span></div>
        </div>
        <div style="flex: 1; min-width: 120px;">
          <div style="font-weight: bold;">INCOME:</div>
          <div>Rental: <span style="font-weight: 500;">${selectedPackage.rentDollar ? "$" + selectedPackage.rentDollar : "-"}</span></div>
          <div>Yield: <span style="font-weight: 500;">${selectedPackage.rentYield ? selectedPackage.rentYield + "%" : "-"}</span></div>
        </div>
      </div>

      <!-- Second Row: Land and Bed/Bath/Car -->
      <div style="display: flex; justify-content: space-between; padding: 0 24px; font-size: 16px; margin-bottom: 24px;">
        <div style="flex: 1; min-width: 120px;">
          <div style="font-weight: bold;">LAND</div>
          <div>Land Price: <span style="font-weight: 500;"> ${selectedPackage.landPrice ? "$" + selectedPackage.landPrice : "-"}</span></div>
          <div>Land Size SQM: <span style="font-weight: 500;">${selectedPackage.landSize || "-"}</span></div>
          <div>Titled: <span style="font-weight: 500;">${selectedPackage.titled || "-"}</span></div>
        </div>
        <div style="flex: 1; min-width: 120px;">
          <div style="font-weight: bold;">BED / BATH / CAR</div>
          <div>Bed: <span style="font-weight: 500;">${selectedPackage.bedrooms || "-"}</span></div>
          <div>Bath: <span style="font-weight: 500;">${selectedPackage.bath || "-"}</span></div>
          <div>Car: <span style="font-weight: 500;">${selectedPackage.carspots || "-"}</span></div>
        </div>
      </div>

      <!-- Footer at the end of the page -->
      <div style="margin-top: auto; border-top: 1px solid #222; padding: 16px; font-size: 12px; color: #222; text-align: center;">
        Warning: The façade image of the property is for illustration purposes only. The actual package you purchase will have the correct façade image, floor plan, inclusions and specifications. Land and build sizes and pricing is subject to change without notice at the discretion of the builder and land developer. Terms, conditions, fees, government charges may apply.
      </div>
    </div>
  `;
};





export const StateReport = async () => {
  try {
    // Convert package file image to base64
    // const packageImageBase64 = await getBase64FromUrl("/Packagefile.png");

    return `
      <div style="border: 2px solid #007A33; padding: 25px; font-family: Arial, sans-serif; max-width: 800px; margin: auto;">
        <h1 style="color: #007A33; font-size: 28px; margin-bottom: 10px;">State Report</h1>

        <img src="CompanyProfile.png" style="width: 100%; height: auto; border-radius: 5px; margin-bottom: 20px;"  />

        <h2 style="color: #007A33; font-size: 26px; border-bottom: 3px solid #007A33; padding-bottom: 5px;">VIC</h2>

        <section style="margin-top: 20px;">
          <h3 style="color: black; font-size: 22px; margin-bottom: 8px;">Immigration & Demand for Housing</h3>
          <ul style="font-size: 18px; color: black; line-height: 1.6; margin-left: 20px;">
            <li><strong>Victoria</strong> is in dire need of employees and immigration is a key</li>
            <li>Housing demand was flat during COVID but is now rebounding</li>
            <li>Unemployment is low, and job creation is a key focus for the state government</li>
          </ul>
        </section>

        <section style="margin-top: 20px;">
          <h3 style="color: black; font-size: 22px; margin-bottom: 8px;">Infrastructure & Job Creation</h3>
          <ul style="font-size: 18px; color: black; line-height: 1.6; margin-left: 20px;">
            <li>Victoria's <strong>Big Build</strong> is progressing with major projects</li>
            <li>Metro Tunnel, major roadworks, and tunnel upgrades</li>
            <li>Melbourne Airport upgrade in progress</li>
          </ul>
        </section>

        <section style="margin-top: 20px;">
          <h3 style="color: black; font-size: 22px; margin-bottom: 8px;">Property Market</h3>
          <ul style="font-size: 18px; color: black; line-height: 1.6; margin-left: 20px;">
            <li>Melbourne's housing market cooled in 2022</li>
            <li>Double-digit growth is expected in late 2023</li>
            <li>Affordable prices and a strong economy are attracting buyers</li>
            <li>Median House Price: <strong>$750,000</strong></li>
          </ul>
        </section>

        <section style="margin-top: 20px;">
          <h3 style="color: black; font-size: 22px; margin-bottom: 8px;">Rental Market</h3>
          <ul style="font-size: 18px; color: black; line-height: 1.6; margin-left: 20px;">
            <li>Rental yields exceeding <strong>4%</strong></li>
            <li>Vacancy rates remain low at <strong>1.3%</strong></li>
          </ul>
        </section>

        <div style="border-top: 3px solid #007A33; margin: 25px 0;"></div>

        <p style="font-size: 14px; color: grey; text-align: center; line-height: 1.5;">
          The information displayed here consists of insights gathered from industry experience. It does not reflect official reports but rather anecdotal facts collected over time from various sources.
        </p>
      </div>
    `;
  } catch (error) {
    console.error('Error in StateReport:', error);
    return '<div>Error loading state report</div>';
  }
};

export const CompanyProfile = () => {
  return `
    <div style="border: 2px solid #1919FF; padding: 15px; font-family: Arial, sans-serif;">
      <div style="text-align: left;">
        <h1 style="color: white; font-size: 28px; margin: 0; padding: 10px; background-color: #1919FF; font-weight: 700;">Company Profile</h1>
      </div>

      <div style="margin: 20px 0;">
        <img src="Team.jpg" style="width: 100%; height: auto; max-height: 400px; object-fit: cover;" />
      </div>


      <div style="text-align: left; line-height: 1.6;">
        <p style="font-size: 16px; margin-bottom: 20px;">
        Fintrack Pty Ltd ACN 006 164
709 is an independent Australian property advisory firm with a diversified approach toward traditional property investment.
        </p>

        <p style="font-size: 16px; margin-bottom: 20px;">
          Our methodology combines high capital growth properties with high cash-flowing residential and commercial assets creating investment strategies unlike any property advisory groups in Australia.
        </p>

        <p style="font-size: 16px; margin-bottom: 20px;">
          Our team of experienced individuals bring impressive connections to our clients along with a deep understanding of the Australian property market.
        </p>

        <p style="font-size: 16px; margin-bottom: 20px;">
          We seek out the best investment opportunities and work together with some of the industry's most respected professionals to identify well-located properties in emerging markets and maximise the value of these assets.
        </p>

        <p style="font-size: 16px; margin-bottom: 20px;">
          We take a long-term approach and make well-considered decisions but are nimble enough to act quickly in securing the best results.
        </p>
      </div>

    </div>
  `;
};

export const Floorplan = (selectedFlyer: any) => {
  return `
    <div style="font-family: Arial, sans-serif; height: 120vh; display: flex; flex-direction: column;">
      <div style="text-align: left;">
        <h1 style="color: white; font-size: 28px; margin: 0; padding: 10px; background-color: #1919FF; font-weight: 700;">Floorplan</h1>
      </div>
      <div style="flex: 1; display: flex; justify-content: center; align-items: center;">
        ${selectedFlyer?.floorPlanimage
      ? `<img src="${selectedFlyer.floorPlanimage}"  alt="Floorplan"style="width: 95%; height: 95%; object-fit: contain;" />`
      : `<span style="color: #222; font-size: 32px; font-weight: 400; text-align: center;">Image of Floorplan</span>`
    }
      </div>
    </div>
  `;
};

export const EstateAndSubdivisionImages = (selectedFlyer: any) => {
  return `
    <div style="font-family: Arial, sans-serif;">
      <div style="background: #1919FF; color: white; font-size: 26px; font-weight: bold; padding: 8px 0 8px 8px; margin-bottom: 10px;">
        Estate
      </div>
      <div style="margin: 0 8px 30px 8px;">
        <div style="width: 100%; height: 500px; display: flex; align-items: center; justify-content: center;">
          ${selectedFlyer?.estateimage
      ? `<img src="${selectedFlyer.estateimage}" alt="Estate" style="max-width: 100%; max-height: 100%; object-fit: contain;" />`
      : `<span style="color: #222; font-size: 32px; font-weight: 400; text-align: center;">Image of Estate</span>`
    }
        </div>
      </div>
      <div style="background: #1919FF; color: white; font-size: 26px; font-weight: bold; padding: 8px 0 8px 8px; margin-bottom: 10px;">
        Subdivision
      </div>
      <div style="margin: 0 8px 30px 8px;">
        <div style="width: 100%; height: 500px;  display: flex; align-items: center; justify-content: center;">
          ${selectedFlyer?.subdivisionImage
      ? `<img src="${selectedFlyer.subdivisionImage}" alt="Subdivision" style="max-width: 100%; max-height: 100%; object-fit: contain;" />`
      : `<span style="color: #222; font-size: 32px; font-weight: 400; text-align: center;">Image of Subdivision</span>`
    }
        </div>
      </div>
    </div>
  `;
};


export const Inclusions = (selectedFlyer: any) => {
  return `
    <div style="font-family: Arial, sans-serif;">
      <div style="text-align: left;">
        <h1 style="color: white; font-size: 28px; margin: 0; padding: 10px; background-color: #1919FF; font-weight: 700;">Inclusions</h1>
      </div>
      <div style="margin: 30px 10px 0 10px; display: flex; justify-content: center; align-items: center;">
        <div style="width: 95%; height: 95%; display: flex; align-items: center; justify-content: center;">
          ${selectedFlyer?.inclusionsimage
      ? `<img src="${selectedFlyer.inclusionsimage}" alt="Inclusions" style="width: 95%; height: 95%; object-fit: contain;" />`
      : `<span style="color: #222; font-size: 32px; font-weight: 400; text-align: center;">Image of Inclusions</span>`
    }
        </div>
      </div>
    </div>
  `;
};

export const RentAppraisal = (selectedPackage: any) => {

  return `
    <div style="font-family: Arial, sans-serif; height: 120vh; display: flex; flex-direction: column;">
      <div style="text-align: left;">
        <h1 style="color: white; font-size: 28px; margin: 0; padding: 10px; background-color: #1919FF; font-weight: 700;">Rent Appraisal</h1>
      </div>
      <div style="flex: 1; display: flex; justify-content: center; align-items: center;">
        ${selectedPackage?.ndiSimage
      ? `<img src="${selectedPackage.ndiSimage}" alt="RentAppraisal" style="width: 95%; height: 95%; object-fit: contain;" />`
      : `<span style="color: #222; font-size: 32px; font-weight: 400; text-align: center;">Image of Rent Appraisal</span>`
    }
      </div>
    </div>
  `;
};

export const ContactUsSection = () => {
  return `
    <div style="font-family: Arial, sans-serif; min-height: 90vh; display: flex; flex-direction: column; justify-content: space-between;">
      <div>
        <div style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
          <img src="fintracklogo.png" alt="Compare New Property" style="height: 60px; margin-bottom: 30px;" />
        </div>
        <div style="text-align: center; margin-bottom: 40px;">
          <p style="font-size: 20px; margin-bottom: 30px;">For more information<br/>please contact us:</p>
          <div style="font-size: 20px; font-weight: bold; margin-bottom: 10px;">Fintrack Pty Ltd<br/>ACN 006 164 709</div>
          <div style="font-size: 18px; margin-bottom: 5px;">help@fintrack.com.au</div>
          <div style="font-size: 18px;">www.fintrack.com.au</div>
        </div>
      </div>
      <div style="width: 100%; text-align: center; position: absolute; bottom: 20px; left: 0;">
        <div style="font-size: 12px; color: #222; margin-top: 40px;">
          <strong>DISCLAIMER</strong><br/>
          Fintrack Pty Ltd ACN 006 164 709 and its staff, contractors or officers make no representation or give no warranty, expressed or implied that the information contained in this document is or will be complete, accurate or suitable for any particular purpose. You should always obtain independent advice on your own personal circumstances prior to proceeding.
        </div>
      </div>
    </div>
  `;
};
